<template>
  <div class="d-flex flex-column grey darken-2 item">
    <video class="black" :src="files + video" autoplay loop muted></video>
  </div>
</template>

<script>
export default {
  computed: {
    video() {
      const video = this.$rest("video").item;
      if (!video.video_desktop) return "";

      return this.xsOnly && video.video_mobile
        ? video.video_mobile
        : video.video_desktop;
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  aspect-ratio: 1920 / 1024;

  @media screen and (max-width: 600px) {
    aspect-ratio: 600 / 600;
  }

  video {
    height: 100%;
    -o-object-fit: cover;
    object-fit: cover;
    width: 100%;
  }
}
</style>
